import type { AccountSave } from '../../game/account';
import type { Progression } from '../../game/Progression';
import type { Actor } from '../../sim/actor';
import type { DialogueState } from './store';

/** Everything the UI may ask the game to do. Implemented by `Game`. */
export interface GameApi {
  readonly account: AccountSave;
  readonly progression: Progression | null;
  readonly player: Actor | null;
  readonly zoneId: string | null;
  readonly zoneKind: string | null;
  createCharacter(name: string, classId: string): string;
  deleteCharacter(id: string): void;
  playCharacter(id: string): Promise<void>;
  exportSave(): string;
  importSave(code: string): void;
  logout(): void;
  dialogueOption(opt: DialogueState['options'][number]): void;
  closeDialogue(): void;
  /** Rebuild the local player's stats/skills after build changes. */
  refreshPlayer(): void;
  useBattleItem(slot: number): void;
  travel(zone: string, spawn: string): void;
  enterInstance(id: string, opts?: Record<string, string | number | boolean>): void;
  leaveInstance(): void;
  save(): void;
  setSetting<K extends keyof AccountSave['settings']>(key: K, value: AccountSave['settings'][K]): void;
  emote(id: string): void;
  sendChat(text: string, channel: string): void;
  interact(): void;
  restDay(): void;
  notify(text: string, color?: string): void;
}

let current: GameApi | null = null;

export function setApi(a: GameApi): void {
  current = a;
}

export function api(): GameApi {
  if (!current) throw new Error('Game API not ready');
  return current;
}
